import React, { useState, useRef, useCallback } from 'react';
import ReactDOM from 'react-dom';

interface HelpTipProps {
  text: string;
}

const HelpTip: React.FC<HelpTipProps> = ({ text }) => {
  const [show, setShow] = useState(false);
  const [pos, setPos] = useState({ top: 0, left: 0 });
  const iconRef = useRef<HTMLSpanElement>(null);

  const handleEnter = useCallback(() => {
    if (!iconRef.current) return;
    const rect = iconRef.current.getBoundingClientRect();
    const spaceBelow = window.innerHeight - rect.bottom;
    const top = spaceBelow < 120
      ? rect.top - 6   // 气泡在上方，bottom 对齐到图标上沿
      : rect.bottom + 6; // 气泡在下方
    setPos({
      top,
      left: rect.left + rect.width / 2,
    });
    setShow(true);
  }, []);

  return (
    <span
      ref={iconRef}
      style={{ display: 'inline-flex', alignItems: 'center', marginLeft: '4px' }}
      onMouseEnter={handleEnter}
      onMouseLeave={() => setShow(false)}
    >
      <span style={{
        display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
        width: '15px', height: '15px', borderRadius: '50%',
        border: '1px solid #c0c4cc', color: '#909399',
        fontSize: '10px', fontWeight: 600, cursor: 'help',
        lineHeight: 1, userSelect: 'none', flexShrink: 0,
      }}>?</span>
      {show && ReactDOM.createPortal(
        <TipBubble text={text} top={pos.top} left={pos.left} above={window.innerHeight - pos.top < 120} />,
        document.body
      )}
    </span>
  );
};

const TipBubble: React.FC<{ text: string; top: number; left: number; above: boolean }> = ({ text, top, left, above }) => {
  const ref = useRef<HTMLDivElement>(null);
  const [adjustedLeft, setAdjustedLeft] = useState(left);

  React.useEffect(() => {
    if (!ref.current) return;
    const rect = ref.current.getBoundingClientRect();
    const pad = 8;
    let newLeft = left;
    if (rect.left < pad) {
      newLeft = left + (pad - rect.left);
    } else if (rect.right > window.innerWidth - pad) {
      newLeft = left - (rect.right - (window.innerWidth - pad));
    }
    if (newLeft !== left) setAdjustedLeft(newLeft);
  }, [left]);

  return (
    <div
      ref={ref}
      style={{
        position: 'fixed',
        [above ? 'bottom' : 'top']: above ? `${window.innerHeight - top}px` : `${top}px`,
        left: `${adjustedLeft}px`,
        transform: 'translateX(-50%)',
        background: '#303133', color: '#fff',
        padding: '8px 12px', borderRadius: '6px',
        fontSize: '0.78rem', lineHeight: 1.5,
        whiteSpace: 'pre-line', width: 'max-content', maxWidth: '280px',
        zIndex: 10000, pointerEvents: 'none',
        boxShadow: '0 2px 8px rgba(0,0,0,0.2)',
      }}
    >
      {text}
    </div>
  );
};

export default HelpTip;
